/**
 * 장부에 적은 생일을 단골 말 한 줄로 (시안 14 L5, 결정 63). 서버는 구조값만 갖고, 문장은 화면이 짓습니다.
 *
 *   시간 있음: 「90년 5월 12일생이에요. 새벽 4시쯤이요.」
 *   시간 모름: 「90년 5월 12일생이에요. 시간은 몰라요.」
 *   음력이면 날짜 앞 「음력 」(윤달이면 「윤5월」). 성별은 넣지 않습니다.
 */

/** 시간대: 0~5 새벽 · 6~11 아침 · 12~17 낮 · 18~21 저녁 · 22~23 밤 */
export function timeBandOf(hour) {
    if (hour < 6) {
        return '새벽';
    }
    if (hour < 12) {
        return '아침';
    }
    if (hour < 18) {
        return '낮';
    }
    if (hour < 22) {
        return '저녁';
    }
    return '밤';
}

/** 시트가 보내는 값({ birthDate: 'YYYY-MM-DD', … })과 서버 장면 값({ year, month, day, … }) 둘 다 받습니다 */
function partsOf(birth) {
    if (birth.birthDate) {
        const [year, month, day] = birth.birthDate.split('-').map(Number);
        return { year, month, day };
    }
    return { year: birth.year, month: birth.month, day: birth.day };
}

/** @returns {string|null} 생일이 없으면(지웠으면) null */
export function formatBirthLine(birth) {
    if (!birth) {
        return null;
    }
    const { year, month, day } = partsOf(birth);
    const lunar = birth.calendarType === 'lunar';
    const date = `${lunar ? '음력 ' : ''}${String(year % 100).padStart(2, '0')}년 ${
        lunar && birth.isLeapMonth ? '윤' : ''
    }${month}월 ${day}일생이에요.`;
    if (!birth.birthTime || birth.timeUnknown) {
        return `${date} 시간은 몰라요.`;
    }
    const hour = Number(birth.birthTime.split(':')[0]);
    const clock = hour % 12 === 0 ? 12 : hour % 12;
    return `${date} ${timeBandOf(hour)} ${clock}시쯤이요.`;
}

/** 생일을 「나」 탭에서 지운 뒤 그 자리에 남는 말 */
export const BIRTH_ENTRY_DELETED = '생일을 장부에서 지웠어요';
